<template>
  <div class="account-settings-wrapper">
    <v-dialog fullscreen transition="dialog-bottom-transition" v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" class="support">settings</v-icon>
      </template>

      <v-card
        v-if="!messaging && !support && !payment_dialog && !packages_dialog"
        class="account-settings"
      >
        <h2 class="text-xs-left">Accounteinstellungen</h2>
        <v-icon @click="dialog = false" class="closeBtn">keyboard_backspace</v-icon>
        <div class="account-settings__groups">
          <!-- list menu -->
          <div class="account-settings__groups-menus">
            <!-- <div class="menu-row">
              <div class="row">
                <v-icon>person</v-icon>
                <h3>Account</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>
            <v-divider></v-divider>-->
            <div @click="support = true" class="menu-row">
              <div class="row">
                <v-icon>help</v-icon>
                <h3>Supportanfrage</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div @click="messaging = true" class="menu-row">
              <div class="row">
                <v-icon>chat</v-icon>
                <h3>Benachrichtigungen</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div @click="passwort_dialog = true" class="menu-row">
              <div class="row">
                <v-icon>lock</v-icon>
                <h3>Passwort ändern</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div
              v-if="user_data.leaguePackage"
              @click="payment_dialog = true"
              :class="['menu-row']"
            >
              <div class="row">
                <v-icon>payment</v-icon>
                <h3>Infos Saisonticket</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div
              v-if="userIsPlayerOrTrainer && payments && payments.length"
              @click="packages_dialog = true"
              :class="['menu-row']"
            >
              <div class="row">
                <v-icon>payment</v-icon>
                <h3>Swipe-Packages</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div
              v-if="user_data.subscriptionData && userType === 'scouts'"
              @click="
                !user_data.subscriptionData.isCanceled
                  ? (subscription_dialog = true)
                  : null
              "
              :class="['menu-row', { inactive: user_data.subscriptionData.isCanceled }]"
            >
              <div class="row">
                <v-icon>block</v-icon>
                <h3>
                  Abo
                  <span v-if="user_data.subscriptionData.isCanceled">gekündigt</span>
                  <span v-else>kündigen</span>
                </h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>

            <div
              @click="
                user_data.subscriptionData && user_data.subscriptionData.isCanceled ||
                !user_data.subscriptionData
                  ? (delete_dialog = true)
                  : null
              "
              :class="[
                'menu-row warn',
                {
                  inactive: user_data.subscriptionData && !user_data.subscriptionData.isCanceled
                },
              ]"
            >
              <div class="row">
                <v-icon>delete</v-icon>
                <h3>Account löschen</h3>
              </div>
              <v-icon>chevron_right</v-icon>
            </div>
          </div>

          <!-- version -->
          <!-- <div class="account-settings__groups-version">{{ deviceId }}</div> -->
          <div class="account-settings__groups-version">v. {{ appVersion }}</div>
        </div>
      </v-card>

      <v-card class="account-settings" v-else-if="packages_dialog">
        <h2>Swipe-Packages</h2>
        <v-icon @click="packages_dialog = false" class="closeBtn"
          >keyboard_backspace</v-icon
        >
        <br />

        <div v-if="payments && payments.length" style="width: 100%">
          <p><b>Package-Details</b></p>
          <v-layout row>
            <v-flex class="settings-label" xs6> Aktuelles Package </v-flex>
            <v-flex class="settings-switch">
              {{ lastPayment.plan_details.name }}
            </v-flex>
          </v-layout>
          <v-layout align-start fill-height>
            <v-flex class="settings-label" xs6> Alle Packages </v-flex>
            <v-flex class="settings-switch">
              <div
                v-for="payment in payments"
                :key="payment.stripe_payment_id"
                color="green white--text"
                style="width: 95%; border-radius: 8px"
                outline
                text
              >
                {{ payment.plan_details.name }}
                <!-- ({{ payment.plan_details.price | clearPrice }})
                <img
                  v-if="payment.payment_method"
                  style="width: 25px; height: 15px;"
                  :src="require(`@/assets/icons/payments/${paymentMethods[payment.payment_method]}.png`)"> -->
              </div>
            </v-flex>
          </v-layout>

          <p class="mt-4"><b>Zahlungsdetails</b></p>
          <v-layout row>
            <v-flex class="settings-label" xs6> Letzte Zahlung </v-flex>
            <v-flex class="settings-switch">
              {{ lastPayment.plan_details.price | clearPrice }}
              <img
                v-if="lastPayment.payment_method"
                style="width: 25px; height: 15px"
                :src="
                  require(
                    `@/assets/icons/payments/${
                      paymentMethods[lastPayment.payment_method]
                    }.png`,
                  )
                "
              />
            </v-flex>
          </v-layout>
          <v-layout align-start fill-height>
            <v-flex class="settings-label" xs6> Alle Zahlungen </v-flex>
            <v-flex class="settings-switch"> {{ sumPayments }} € </v-flex>
          </v-layout>
        </div>
        <div v-else>Keine Daten gefunden.</div>

        <v-card-actions style="justify-content: center">
          <!-- <v-btn color="white green--text" text @click="payment_dialog = false">Schließen</v-btn> -->
        </v-card-actions>
      </v-card>

      <v-card class="account-settings" v-else-if="payment_dialog">
        <h2>Infos Saisonticket</h2>
        <v-icon @click="payment_dialog = false" class="closeBtn"
          >keyboard_backspace</v-icon
        >
        <br />
        <div v-if="user_data.leaguePackage" style="width: 100%">
          <p><b>Aktuelles Saisonticket</b></p>
          <!-- <span>Status: {{ subscriptionData.subscription.status }}</span><br> -->
          <!-- <v-layout>
            <v-flex class="settings-label" xs6>
              Aktuelles Abo
            </v-flex>
            <v-flex class="settings-switch">
              {{ currentAbo }}
            </v-flex>
          </v-layout> -->
          <v-layout v-if="!!user_data.leaguePackage.boughtAt">
            <v-flex class="settings-label" xs6> Gekauft am </v-flex>
            <v-flex class="settings-switch">
              {{
                new Date(user_data.leaguePackage.boughtAt).toLocaleDateString('de-DE')
              }}
            </v-flex>
          </v-layout>
          <v-layout v-if="!!user_data.leaguePackage.boughtFor">
            <v-flex class="settings-label" xs6> Gesamte Laufzeit </v-flex>
            <v-flex class="settings-switch">
              {{ user_data.leaguePackage.boughtFor }} Monate
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="settings-label" xs6> Endet automatisch am </v-flex>
            <v-flex class="settings-switch">
              30.06.{{ user_data.leaguePackage.activeToDate }}
            </v-flex>
          </v-layout>

          <p class="mt-4"><b>Zahlungsdetails</b></p>
          <v-layout v-if="paidSum">
            <v-flex class="settings-label" xs6> Rechnungsbetrag Brutto </v-flex>
            <v-flex class="settings-switch"> {{ paidSum }} € </v-flex>
          </v-layout>
          <v-layout v-if="paidSum">
            <v-flex class="settings-label" xs6> Inkludierte MwSt. </v-flex>
            <v-flex class="settings-switch">
              {{ (paidSum - paidSum / 1.19).toFixed(2) }} €
            </v-flex>
          </v-layout>
          <v-layout v-if="user_data.leaguePackage.paidBy">
            <v-flex class="settings-label" xs6> Zahlungsart </v-flex>
            <v-flex class="settings-switch">
              <img
                v-if="user_data.leaguePackage.paidBy"
                style="width: 45px; height: 25px"
                :src="
                  require(
                    `@/assets/icons/payments/${
                      paymentMethods[user_data.leaguePackage.paidBy]
                    }.png`,
                  )
                "
              />
            </v-flex>
          </v-layout>

          <v-layout style="text-align: center; padding-top: 20px">
            <v-flex>
              <v-btn
                color="green white--text"
                style="width: 80%; border-radius: 8px"
                text
                @click="sendInvoiceInfoMail"
              >
                Du benötigst eine Rechnungskopie?
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>Kein Stripe-Abo oder PayPal Abo ist aktiv.</div>

        <v-card-actions style="justify-content: center">
          <!-- <v-btn color="white green--text" text @click="payment_dialog = false">Schließen</v-btn> -->
        </v-card-actions>
      </v-card>

      <v-card class="account-settings" v-else-if="messaging">
        <h2>Benachrichtigungen</h2>
        <v-icon @click="messaging = false" class="closeBtn">keyboard_backspace</v-icon>

        <div
          class="push-not-allowed"
          v-if="!$store.state.pushNotificationsAllowedInBrowser"
        >
          Um Push-Message zu aktivieren, gehe bitte in die Einstellungen deines
          Browsers.
        </div>

        <div class="messaging-wrapper">
          <div class="row">
            <div style="width: 100%">
              <p><b>Per E-Mail</b></p>

              <v-layout align-start fill-height v-if="userType === 'teams'">
                <v-flex class="settings-label" xs6> Neue Connect-Anfrage </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingEmailConnection"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout
                align-start
                fill-height
                v-if="userType === 'trainers' || userType === 'users'"
              >
                <v-flex class="settings-label" xs6> Neues Match </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingEmailMatch"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout align-start fill-height>
                <v-flex class="settings-label" xs6> Neue Nachricht </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingEmailChat"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>

              <p style="margin: 10px 0"><b>Per Push-Message*</b></p>

              <v-layout align-start fill-height v-if="userType === 'teams'">
                <v-flex class="settings-label" xs6> Neue Connect-Anfrage </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingPushConnection"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout
                align-start
                fill-height
                v-if="userType === 'trainers' || userType === 'users'"
              >
                <v-flex class="settings-label" xs6> Neues Match </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingPushMatch"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout align-start fill-height>
                <v-flex class="settings-label" xs6> Neue Nachricht </v-flex>
                <v-flex class="settings-switch">
                  <v-switch
                    color="green"
                    v-model="messagingPushChat"
                    label=""
                  ></v-switch>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <div class="account-settings__groups-version" style="padding: 15px 0">
            *Unterstützt für iOS-Geräte von Apple mit Safari v16.4 oder höher.
          </div>
        </div>
      </v-card>

      <v-card class="account-settings" v-else>
        <h2>Supportanfrage</h2>
        <br />
        <p>
          Eröffne jetzt ein Ticket mit deiner Anfrage. Unser Support wird sich dann
          schnellstmöglich per E-Mail bei dir melden. Danke.
        </p>
        <v-textarea
          solo
          color="green"
          style="flex: 0 1 auto"
          placeholder="Bitte beschreibe dein Problem."
          v-model="user_data.support_ticket"
        ></v-textarea>

        <v-card-actions style="justify-content: center">
          <v-btn color="white green--text" text @click="support = false"
            >Schließen</v-btn
          >
          <v-btn
            :disabled="!user_data.support_ticket"
            color="green white--text"
            text
            @click="sendSupport"
            >Senden</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="subscription_dialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline">Abo kündigen</v-card-title>

        <v-card-text>
          Du möchtest dein Match-Abo wirklich kündigen? Damit würdest du nach Ablauf
          deines Abos nicht mehr unbegrenzt matchen können!
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="subscription_dialog = false">Schließen</v-btn>
          <v-btn
            :loading="loading"
            color="red white--text"
            text
            @click="cancelSubscription"
            >Kündigen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="passwort_dialog">
      <v-card class="dialog">
        <v-card-title class="headline">Passwort ändern</v-card-title>
        <v-card-text>
          <label for>Neues Passwort</label>
          <v-text-field
            :rules="[rules.min]"
            type="password"
            color="green"
            solo
            v-model="pw1"
          ></v-text-field>
          <label for>Passwort wiederholen</label>
          <v-text-field
            :rules="[passwordConfirmationRule]"
            type="password"
            color="green"
            solo
            v-model="pw2"
          ></v-text-field>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="passwort_dialog = false">Schließen</v-btn>

          <v-btn
            color="green white--text"
            :disabled="pw1 !== pw2 || pw1 === '' || pw2 === ''"
            text
            @click="resetPW"
            :loading="loading"
            >Ändern</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_dialog" max-width="290">
      <v-card class="dialog">
        <v-card-title :loading="loading" class="headline">Account löschen</v-card-title>

        <v-card-text>
          Du möchtest deinen Account wirklich löschen? Damit gehen alle deine Daten
          sowie ggf. noch
          {{ userIsPlayerOrTrainer ? 'freie Swipes' : 'freie Matches' }} verloren und
          kann nicht wieder rückgängig gemacht werden!
          <b>Bist du dir sicher?</b>

          <br /><br />

          <p>Bestätige den Löschvorgang bitte mit deinem Passwort.</p>

          <label for>Passwort</label>
          <v-text-field
            type="password"
            color="green"
            solo
            v-model="deleteUserPassConfirmation"
          ></v-text-field>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="delete_dialog = false">Schließen</v-btn>

          <v-btn color="red white--text" text @click="deleteUser">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-snackbar class="snack snack-green" :top="true" :timeout="0" v-model="askForPushPermition">
      <b>
        Möchtest du Push-Message erlauben?
      </b>
      <v-btn color="white" flat icon @click="requestSafariPersission(); askForPushPermition = false">
        <v-icon>check_circle_outline</v-icon>
      </v-btn>
      <v-btn color="red" flat icon @click="askForPushPermition = false">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-snackbar> -->
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import firebase from 'firebase';
import { mapState } from 'vuex';
import { db } from '@/db';
import { version } from '../../../package.json';
import { cloudFunctions } from '../../config';
import stripeMixin from '../../mixins/stripe';
import pushNotificationsMixin from '../../mixins/push-notifications';

export default {
  name: 'account-settings',

  data: () => ({
    dialog: false,
    support: false,
    messaging: false,
    passwort_dialog: false,
    delete_dialog: false,
    subscription_dialog: false,
    payment_dialog: false,
    packages_dialog: false,
    loading: false,
    cancel_reason: '',
    pw1: '',
    pw2: '',
    rules: {
      min: (v) => v.length >= 8 || 'Passwort muss mindest 8 Zeichen haben',
    },
    appVersion: `${version}`,
    invoices: {},
    currency: {
      eur: '€',
      usd: '$',
    },
    period: {
      month: 'Monate',
      year: 'Jahr',
    },
    paymentMethods: {
      card: 'mastercard',
      iban: 'banktransfer',
      sofort: 'klarna-sofort',
      giropay: 'giropay',
      mobile: 'applepay',
      paypal: 'paypal',
    },
    deleteUserPassConfirmation: '',
    deviceId: '',
    messagingEmailChat: false,
    messagingEmailMatch: false,
    messagingEmailConnection: false,
    messagingPushChat: false,
    messagingPushMatch: false,
    messagingPushConnection: false,
  }),

  mixins: [stripeMixin, pushNotificationsMixin],

  filters: {
    formatDate(timestamp) {
      return moment.unix(timestamp).format('DD.MM.YYYY');
    },

    clearPrice(price) {
      return price.replace(' *', '').replace(',', '.').replace('€', ' €');
    },
  },

  watch: {
    messagingEmailChat(val) {
      this.updateUserAccount({ messagingEmailChat: val });
    },
    messagingEmailMatch(val) {
      this.updateUserAccount({ messagingEmailMatch: val });
    },
    messagingEmailConnection(val) {
      this.updateUserAccount({ messagingEmailConnection: val });
    },
    messagingPushChat(val) {
      this.updateUserAccount({ messagingPushChat: val });
      if (val) {
        if (this.$messaging) {
          this.messagingRegister(val);
        }
      } else {
        this.setTokenSentToServer(false);
      }
    },
    messagingPushConnection(val) {
      this.updateUserAccount({ messagingPushConnection: val });
      if (val) {
        if (this.$messaging) {
          this.messagingRegister(val);
        }
      } else {
        this.setTokenSentToServer(false);
      }
    },
    messagingPushMatch(val) {
      this.updateUserAccount({ messagingPushMatch: val });
      if (val) {
        if (this.$messaging) {
          this.messagingRegister(val);
        }
      } else {
        this.setTokenSentToServer(false);
      }
    },
    user_data(val) {
      this.setSwitchesValues(val);
    },
  },

  methods: {
    async sendInvoiceInfoMail() {
      const data = {
        email: this.user_data.email,
        name: this.user_data.team_name,
        lastPayment: this.paidSum,
      };

      try {
        await axios({
          method: 'post',
          url: `${cloudFunctions}/sendInvoiceEmail`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data,
        });

        this.$store.commit({
          type: 'openSnackbar',
          text: 'E-Mail wurde geschickt.',
        });
      } catch (error) {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Ups, E-Mail wurde nicht geschickt.',
        });
      }
    },

    setSwitchesValues(val) {
      const {
        // messagingPush,
        messagingPushChat,
        messagingPushMatch,
        messagingPushConnection,
        messagingEmailChat,
        messagingEmailMatch,
        messagingEmailConnection,
      } = val;

      // this.messagingPush = messagingPush !== undefined ? messagingPush : false;
      this.messagingPushChat =
        messagingPushChat !== undefined ? messagingPushChat : false;
      this.messagingPushMatch =
        messagingPushMatch !== undefined ? messagingPushMatch : false;
      this.messagingPushConnection =
        messagingPushConnection !== undefined ? messagingPushConnection : false;
      this.messagingEmailChat =
        messagingEmailChat !== undefined ? messagingEmailChat : false;
      this.messagingEmailMatch =
        messagingEmailMatch !== undefined ? messagingEmailMatch : false;
      this.messagingEmailConnection =
        messagingEmailConnection !== undefined ? messagingEmailConnection : false;
    },

    async getAllInvoices(customerId) {
      const userInvoices = await axios({
        method: 'post',
        url: `${cloudFunctions}/stripeGetAllInvoices`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: { customerId },
      });
      return userInvoices.data.invoices;
    },

    resetPW() {
      const user = firebase.auth().currentUser;
      this.loading = true;
      user
        .updatePassword(this.pw1)
        .then(() => {
          // Update successful.
          this.loading = false;
          this.passwort_dialog = true;
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Passwort geändert',
          });
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
          this.loading = false;
          let text = 'Ups, da ist etwas schief gelaufen';
          if (error.code == 'auth/requires-recent-login') {
            text =
              'Du bist zu lange angemeldet. Logge dich nochmal aus und neu ein um dein Passwort zu ändern.';
          }
          this.$store.commit({
            type: 'openSnackbar',
            text,
          });
        });
    },

    async deleteUser() {
      this.$store.state.loading = true;
      this.$store.state.accountDeleted = true;
      const at = this.userType;
      const user = firebase.auth().currentUser;

      const userReauth = await firebase
        .auth()
        .signInWithEmailAndPassword(
          this.user_data.email,
          this.deleteUserPassConfirmation,
        )
        .catch((err) => {
          this.$store.state.loading = false;
          this.$store.commit({
            type: 'openSnackbar',
            text: err.message,
          });
        });

      if (!userReauth) {
        this.$store.state.loading = false;
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Dein Passwort ist falsch.',
        });
        return;
      }
      const allUpdates = [];

      if (at === 'users' || at === 'trainers') {
        // update applications in teams
        if (this.user_data.applied_teams && this.user_data.applied_teams.length) {
          this.user_data.applied_teams.forEach(async (teamId) => {
            const refTeam = db.collection('teams').doc(teamId);
            const teamSnap = await refTeam.get();
            const applicationField =
              at === 'users' ? 'applications' : 'trainer_applications';
            const teamApplicationsUpdated = teamSnap
              .data()
              [applicationField].filter((accountId) => accountId !== this.user_data.id);

            allUpdates.push(refTeam.update({ applications: teamApplicationsUpdated }));
          });
        }
      } else if (at === 'teams') {
        // update applications in players/trainers
        if (this.user_data.applications && this.user_data.applications.length) {
          this.user_data.applications.forEach(async (playerId) => {
            const refUser = db.collection('users').doc(playerId);
            const userSnap = await refUser.get();
            const userApplicationsUpdated = userSnap
              .data()
              .applied_teams.filter((accountId) => accountId !== this.user_data.id);

            allUpdates.push(refUser.update({ applied_teams: userApplicationsUpdated }));
          });
        }
        if (
          this.user_data.trainer_applications &&
          this.user_data.trainer_applications.length
        ) {
          this.user_data.trainer_applications.forEach(async (trainerId) => {
            const refTrainer = db.collection('trainers').doc(trainerId);
            const trainerSnap = await refTrainer.get();
            const trainerApplicationsUpdated = trainerSnap
              .data()
              .applied_teams.filter((accountId) => accountId !== this.user_data.id);

            allUpdates.push(
              refTrainer.update({ applied_teams: trainerApplicationsUpdated }),
            );
          });
        }
      }

      // update matches collection and already_matched in teams/scouts/users/trainers
      if (this.user_data.matches && this.user_data.matches.length) {
        this.user_data.matches.forEach(async (matchId) => {
          // update matches collection
          const refMatch = db.collection('matches').doc(matchId);
          allUpdates.push(refMatch.delete());
          // update messages collection
          const refMessages = db.collection('messages').doc(matchId);
          allUpdates.push(refMessages.delete());

          // update already_matched in teams/scouts
          const matchedAccountId = matchId.replace(this.user_data.id, '');

          // check teams
          if (at !== 'teams') {
            const refTeam = db.collection('teams').doc(matchedAccountId);
            const teamSnap = await refTeam.get({ source: 'server' });

            if (teamSnap.data()) {
              if (teamSnap.data().already_matched) {
                const alreadyMatchedDataInTeamUpdated = teamSnap
                  .data()
                  .already_matched.filter((id) => id !== this.user_data.id);
                allUpdates.push(
                  refTeam.update({ already_matched: alreadyMatchedDataInTeamUpdated }),
                );
              }

              if (teamSnap.data().matches) {
                const matchesInTeamUpdated = teamSnap
                  .data()
                  .matches.filter((id) => id !== matchId);
                allUpdates.push(refTeam.update({ matches: matchesInTeamUpdated }));
              }
            }
          }

          // check scouts
          if (at !== 'scouts') {
            const refScout = db.collection('scouts').doc(matchedAccountId);
            const scoutSnap = await refScout.get({ source: 'server' });

            if (scoutSnap.data()) {
              if (scoutSnap.data().already_matched) {
                const alreadyMatchedDataInScoutUpdated = scoutSnap
                  .data()
                  .already_matched.filter((id) => id !== this.user_data.id);
                allUpdates.push(
                  refScout.update({
                    already_matched: alreadyMatchedDataInScoutUpdated,
                  }),
                );
              }

              if (scoutSnap.data().matches) {
                const matchesInScoutUpdated = scoutSnap
                  .data()
                  .matches.filter((id) => id !== matchId);
                allUpdates.push(refScout.update({ matches: matchesInScoutUpdated }));
              }
            }
          }

          // check users
          if (at !== 'users' && at !== 'trainers') {
            const ref = db.collection('users').doc(matchedAccountId);
            const snap = await ref.get({ source: 'server' });

            if (snap.data()) {
              if (snap.data().already_matched) {
                const alreadyMatchedDataUpdated = snap
                  .data()
                  .already_matched.filter((id) => id !== this.user_data.id);
                allUpdates.push(
                  ref.update({ already_matched: alreadyMatchedDataUpdated }),
                );
              }

              if (snap.data().matches) {
                const matchesUpdated = snap
                  .data()
                  .matches.filter((id) => id !== matchId);
                allUpdates.push(ref.update({ matches: matchesUpdated }));
              }
            }
          }

          // check trainers
          if (at !== 'users' && at !== 'trainers') {
            const ref = db.collection('trainers').doc(matchedAccountId);
            const snap = await ref.get({ source: 'server' });

            if (snap.data()) {
              if (snap.data().already_matched) {
                const alreadyMatchedDataUpdated = snap
                  .data()
                  .already_matched.filter((id) => id !== this.user_data.id);
                allUpdates.push(
                  ref.update({ already_matched: alreadyMatchedDataUpdated }),
                );
              }

              if (snap.data().matches) {
                const matchesUpdated = snap
                  .data()
                  .matches.filter((id) => id !== matchId);
                allUpdates.push(ref.update({ matches: matchesUpdated }));
              }
            }
          }
        });
      }

      await Promise.all(allUpdates)
        .then(async () => {
          const refAccount = db.collection(at).doc(this.user_data.id);
          await refAccount.delete();

          await user.delete();

          const data = {
            email: this.user_data.email,
            name:
              this.user_data.userType === 'teams'
                ? this.user_data.team_name
                : this.user_data.firstname || this.user_data.name,
            type: this.user_data.userType,
          };
          await axios({
            method: 'post',
            url: `${cloudFunctions}/sendByeEmail`,
            headers: {
              'content-type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data,
          });

          this.$store.commit({
            type: 'openSnackbar',
            text: 'Dein Account wurde gelöscht.',
          });
          this.$store.state.loading = false;
          // will be redirected to /cancelation in App in onAuthStateChanged hook
        })
        .catch(async (err) => {
          console.log(err);
          // save error to db
          await axios({
            method: 'post',
            url: `${cloudFunctions}/saveError`,
            headers: {
              'content-type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: {
              error: JSON.stringify(err),
              user: this.user_data.id,
              source: 'delete_account',
            },
          });

          this.$store.commit({
            type: 'openSnackbar',
            text: 'Ups, da ist etwas schief gelaufen.',
          });
          this.$store.state.loading = false;
          setTimeout(() => {
            console.log('redirect after delete with problems');
            this.$router.push({ name: 'cancelation' });
          }, 600);
        });
    },

    checkUserSession() {
      return !!this.credentials;
    },

    cancelSubscription() {
      this.$store.state.loading = true;
      if (this.user_data.subscriptionData.subscriptionId.startsWith('sub_')) {
        this.cancelSubscriptionStripe({
          subscriptionId: this.user_data.subscriptionId,
        });
      } else {
        this.cancelSubscriptionPaypal();
      }
    },

    cancelSubscriptionPaypal() {
      this.loading = true;
      let at;
      if (this.user_data.userType === 'trainer') {
        at = 'trainers';
      }
      if (this.user_data.userType === 'player') {
        at = 'users';
      }
      if (this.user_data.userType === 'scout') {
        at = 'scouts';
      }
      if (this.user_data.userType === 'team') {
        at = 'teams';
      }
      const data = {
        subscriptionId: this.user_data.subscriptionData.subscriptionId,
      };
      const json = JSON.stringify(data);

      axios({
        method: 'post',
        url: `${cloudFunctions}/cancelSubscription`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then(() => {
          const subscriptionExpiryDate = this.getExpiryDate();
          
          this.user_data.subscriptionData.isCanceled = true;
          this.user_data.subscriptionData.subscriptionExpiryDate = subscriptionExpiryDate;
          this.user_data.swipesLeft = 0;
          
          this.loading = false;
          this.$store.state.loading = false;
          this.subscription_dialog = false;
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Dein Abo wurde gekündigt.',
          });
          db.collection(at)
            .doc(this.$store.state.user_data.id)
            .update({ ...this.$store.state.user_data });
        })
        .catch((e) => {
          this.$store.state.loading = false;
          this.loading = false;
          console.log(e);
        });
    },

    sendSupport() {
      const data = {
        support_ticket: this.user_data.support_ticket,
        email: this.user_data.email,
      };
      const json = JSON.stringify(data);
      axios({
        method: 'post',
        url: `${cloudFunctions}/sendSupportMail`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then(() => {
          this.support = false;
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Ticket gesendet',
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    redirectToInvoices(invoice) {
      window.open(invoice.hosted_invoice_url);
    },
  },

  computed: {
    ...mapState([
      'user_data',
      'userType',
      'credentials',
      'subscriptionData',
      'payments',
    ]),

    paidSum() {
      return this.user_data.leaguePackage.paid
        ? (this.user_data.leaguePackage.paid / 100).toFixed(2)
        : 0;
    },

    lastPayment() {
      const { plan_details, payment_method } = this.payments[0];
      return { plan_details, payment_method };
      // return `${plan_details.name} (${plan_details.price})`;
    },

    sumPayments() {
      const sum = this.payments.reduce(
        (acc, payment) => acc + payment.plan_details.value,
        0,
      );
      return (sum / 100).toFixed(2);
    },

    currentAbo() {
      const { plan } = this.subscriptionData.subscription.items.data[0];
      return `${plan.interval_count} ${this.period[plan.interval]}`;
    },

    sumAbos() {
      const invoices = this.invoices.data;
      if (!invoices) return '-';

      const sum = invoices.reduce((acc, invoice) => acc + invoice.amount_paid, 0);
      return (sum / 100).toFixed(2);
    },

    userIsPlayerOrTrainer() {
      return this.userType === 'users' || this.userType === 'trainers';
    },

    invoicesWithoutFirst() {
      return this.invoices.data.slice(1);
    },

    paymentsWithoutFirst() {
      return this.payments.slice(1);
    },

    // cancel_reason() {
    //   const scoutteam = [
    //     "Die Funktionalität und/oder das Design der App gefällt mir nicht.",
    //     "Die App hat nicht meine Erwartungen erfüllt bzw. habe ich mir etwas anderes vorgestellt.",
    //     "Ich habe keinen passenden Spieler oder Trainer gefunden.",
    //     "Ich habe einen Spieler oder Trainer gefunden und benötige die App nicht mehr.",
    //     "Die C4T-Membership ist mir zu teuer bzw. bin ich nicht bereit dafür zu bezahlen.",
    //     "Es gibt einen anderen Grund."
    //   ];
    //   const playertrainer = [
    //     "Die Funktionalität und/oder das Design der App gefällt mir nicht.",
    //     "Die App hat nicht meine Erwartungen erfüllt bzw. habe ich mir etwas anderes vorgestellt.",
    //     "Ich habe keinen passenden Verein gefunden.",
    //     "Ich habe einen Verein gefunden und benötige die App nicht mehr.",
    //     "Die C4T-Membership ist mir zu teuer bzw. bin ich nicht bereit dafür zu bezahlen.",
    //     "Es gibt einen anderen Grund."
    //   ];
    //   return this.user_data.userType === "Scout" ||
    //     this.user_data.userType === "Team"
    //     ? scoutteam
    //     : playertrainer;
    // },
    passwordConfirmationRule() {
      return () => this.pw1 === this.pw2 || 'Passworter müssen übereinstimmen';
    },
  },

  async created() {
    if (this.user_data.stripe_customer) {
      const invoices = await this.getAllInvoices(
        this.user_data.stripe_customer.stripe_customer_id,
      );
      this.invoices = invoices;
    }
    this.setSwitchesValues(this.user_data);
    // this.deviceId = MediaDeviceInfo.deviceId;
  },
};
</script>

<style lang="scss" scoped>
.account-settings-wrapper {
  position: absolute;
  top: 15px;
  right: 20px;
}

.settings-switch {
  padding-left: 0px;
  margin-bottom: 3px;
  padding: 5px 0;
}

.settings-label {
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
  padding: 5px 0;

  &--inprogress {
    color: rgb(134, 134, 134);
    font-style: italic;
  }
}

.dialog {
  text-align: left;
  padding: 15px;
}

.support {
  color: black;
}

.warn {
  color: red;
}

.inactive {
  color: lightgrey;
}

.account-settings {
  padding-top: 50px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  text-align: left;

  width: 768px;
  max-width: 100vw;

  display: flex;
  flex-direction: column;

  min-width: unset !important;
  margin: auto !important;

  &__groups {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &-version {
      padding: 10px;
      font-size: 10px;
      color: #616161;
      margin-bottom: 70px;
    }
  }
}

.menu-row {
  cursor: pointer;
  padding: 20px 0px;

  h3 {
    margin-left: 20px;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid lightgray;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
